import { render } from "./index-two.vue?vue&type=template&id=5a15524c"
import script from "./index-two.vue?vue&type=script&lang=js"
export * from "./index-two.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__